export default __webpack_public_path__ + "static/media/logo.494b8ed0.jpg";